import React from 'react'
import { useSelector } from 'react-redux'
import { ButtonV2 } from '@labrav/react-components'
import { LoadingTypes } from '../../modules/loading/reducer'
import { isLoading } from '../../utils/loadingState'
import type { CompanyInfoRootState } from './companyInfoState'

export const CompanyInfoContinueButton: React.FC = () => {
  const loading = useSelector((state: CompanyInfoRootState) =>
    isLoading(state.loading)(LoadingTypes.COMPANY_INFORMATION)
  )

  return (
    <ButtonV2 type="submit" data-testid="continue-button" loading={loading}>
      Continue
    </ButtonV2>
  )
}
